module.exports = __webpack_public_path__ + "static/media/sneak-peek-background.620a3d06.png";